import React, { useState } from 'react'
import styles from '@styles/post-detail.module.css'
import { Post as IPost } from '@api/types'
import Post from '@ui/components/post'
interface IPostDetail {
  post: IPost
}
function PostDetail(props: IPostDetail) {
  const [playingVideoId, setPlayingVideoId] = useState<null | string>(null)
  const togglePlaying = (id: string) => {
    setPlayingVideoId((prevPlayingVideoId: string | null) => {
      return prevPlayingVideoId === id ? null : id
    })
  }

  const { post } = props
  return (
    <div className={styles.container}>
      <Post
        key={post.id}
        post={post}
        playing={playingVideoId === post.id}
        togglePlaying={() => togglePlaying(post.id)}
        startPlaying={() => setPlayingVideoId(post.id)}
        stopPlaying={() => setPlayingVideoId(null)}
        ignoreVisibilityChanges
      />
    </div>
  )
}

export default PostDetail
